import Vue from 'vue'

export const storeUser = Vue.observable({
  userBlock: {
    u: '',
    p: ''
  }
})
export const mutationUser = {
  setUBlock: (u) => {
    storeUser.userBlock.u = u
  },
  setPBlock: (p) => {
    storeUser.userBlock.p = p
  }
}
